import { Injectable } from '@angular/core';
import { IIDgenericSuspensionStore } from './genericSuspension.store';
import { IID_GENERIC_SUSPENSION } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDgenericSuspensionQuery } from './genericSuspension.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.GENERIC_SUSPENSION)
export class IIDgenericSuspensionService extends CrudService<IID_GENERIC_SUSPENSION, IIDgenericSuspensionStore, IIDgenericSuspensionQuery> {
  constructor(
    protected store: IIDgenericSuspensionStore,
    public query: IIDgenericSuspensionQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_GENERIC_SUSPENSION,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
